import React from 'react';
import { Default, Mobile } from '../responsive';
import { getPortNameWithShy } from '../utils';
import { createDescriptionString, getCurrentPort } from '../utilsVisits';
import Icons, { IconNames } from './icons';
import VisitList from './visitlist';
import Modal from './modal';
import ListItemDetails from './listItemDetails';

export default class VesselListItem extends React.Component {
  constructor(props) {
    super(props);
    this.onClickItem = this.onClickItem.bind(this);
    this.onClickItemDetail = this.onClickItemDetail.bind(this);
    this.onUpdateStatus = this.onUpdateStatus.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.state = {
      showChildren: props.showChildren ? true : false,
      showChildrenDetails: false,
      details: {},
      detailsHeaders: {},
      status: '',
      lang: this.props.lang || 'en'
    };

    this.myRef = React.createRef();
    this.ports = null;
  }

  componentWillMount() {
    this.ports = getCurrentPort(this.props.visits);
  }

  componentDidMount() {
    const status = createDescriptionString(this.props.visits, this.ports);

    this.setState({ status });

    if (this.props.showChildren) {
      window.scrollTo({
        top: this.myRef.current.offsetTop,
        behavior: 'smooth'
      });
    }
  }

  itemShouldBeHighlighted(index) {
    if (this.props.itemHighlights === null || this.props.itemHighlights === undefined) {
      return false;
    }
    return this.props.itemHighlights.find(i => index === i) !== undefined;
  }

  onClickItem() {
    if (this.state.showChildrenDetails) {
      this.setState({ showChildrenDetails: false });
    } else {
      this.setState({ showChildren: !this.state.showChildren }, () => {
        if (!this.state.showChildren) {
          this.props.onToggleChildren(null);
        } else {
          this.props.onToggleChildren(this.props.index);
        }

        this.forceUpdate();
      });
    }
  }

  onUpdateStatus(status) {
    this.setState({ status });
  }

  onModalClose() {
    this.setState({ showChildren: false });
  }

  renderCell(item, key, index) {
    const cssClasses = ['list__items__item__vessel__info'];
    const itemWithShy = getPortNameWithShy(item);
    let content = null;

    if (this.itemShouldBeHighlighted(index)) {
      cssClasses.push('list__items__highlight');
    }

    if (itemWithShy) {
      content = <div className="inner" dangerouslySetInnerHTML={{ __html: itemWithShy }} />;
    } else {
      content = <div className="inner">{item}</div>;
    }

    const i18n = {
      is: {
        'Voyage': 'Ferð',
        'Vessel': 'Skip',
        'Route': 'Leið',
        'Updated': 'Uppfært',
      },
      en: {
        'Voyage': 'Voyage',
        'Vessel': 'Vessel',
        'Route': 'Route',
        'Updated': 'Updated',
      }
    }
    const title = i18n[this.props.lang][key]

    return (
      <span key={index} className={cssClasses.join(' ')} onClick={this.onClickItem}>
        <div className="list__items__item__vessel__header">{title}</div>
        {content}
      </span>
    );
  }

  renderItem() {
    const items = this.props.items;
    const headers = this.props.headers || this.props.items;

    return (
      <React.Fragment>
        <Default>
          {Object.keys(headers).map((key, index) => {
            const item = items[key];
            const header = headers[key];
            return this.renderCell(item, header, index);
          })}
        </Default>
        <Mobile>
          {this.renderCell(items['Reference'], headers['Reference'], 0)}
          {this.renderCell(items['Updated'], headers['Updated'], 0)}
        </Mobile>
      </React.Fragment>
    );
  }

  renderOpenCloseIcon() {
    return (
      <Icons
        iconName={IconNames.ArrowUp}
        iconClassName={this.state.showChildren ? 'openCloseIcon' : 'openCloseIcon Down'}
        className="openCloseWrapper"
        onClick={this.onClickItem}
      />
    );
  }

  renderVisitsList(visitsDTO) {
    return (
      <VisitList
        visits={visitsDTO}
        portRegistry={this.props.portRegistry}
        showingGMT={this.props.showingGMT}
        onUpdateStatus={this.onUpdateStatus}
        lang={this.state.lang}
      />
    );
  }

  renderStatus() {
    return (
      <span className="list__items__item__vessel__info status" onClick={this.onClickItem}>
        <div className="list__items__item__vessel__header">{this.props.lang === 'is' ? 'Staða' :'Status'}</div>
        <div className="inner">{this.state.status}</div>
      </span>
    );
  }

  renderLastUpdated() {
    return (
      <span className="list__items__item__vessel__info status" onClick={this.onClickItem}>
        <div className="list__items__item__vessel__header">{this.props.lang === 'is' ? 'Uppfært' :'Updated'}</div>
        <div className="inner">{this.state.status}</div>
      </span>
    );
  }

  renderVisitListHeader() {
    let header = `${this.props.items['Reference']} ${this.props.items['Name']}`;

    if (this.state.showChildrenDetails) {
      header = this.state.details.Port;
    }

    return (
      <div className="visitlist__header">
        <Icons
          iconName={IconNames.ArrowUp}
          iconClassName={this.state.showChildren ? 'openCloseIcon back' : 'openCloseIcon'}
          className="openCloseWrapper"
          onClick={this.onClickItem}
        />
        <div>
          <div className="visitlist__header__title">{header}</div>
          <div className="visitlist__header__subtitle">{this.state.status}</div>
        </div>
      </div>
    );
  }

  onClickItemDetail(itemDetail, itemDetailHeaders) {
    if (!itemDetail.inTransit) {
      this.setState({
        showChildrenDetails: true,
        details: itemDetail,
        detailsHeaders: itemDetailHeaders
      });
    }
  }

  renderChildren() {
    if (this.state.showChildrenDetails) {
      return (
        <ListItemDetails items={this.state.details} headers={this.state.detailsHeaders} tag="div" lang={this.state.lang} />
      );
    } else {
      return (
        <VisitList
          visits={this.props.visits}
          portRegistry={this.props.portRegistry}
          showingGMT={this.props.showingGMT}
          onUpdateStatus={this.onUpdateStatus}
          showClosingTimes={this.props.showClosingTimes}
          ports={this.ports}
          onClickItem={this.onClickItemDetail}
          nextVoyage={this.props.nextVoyage}
          lang={this.state.lang}
        />
      );
    }
  }

  render() {
    const Tag = this.props.tag;

    const css = [this.props.className];

    if (this.props.lastPort) {
      css.push('lastPort');
    }

    if (this.state.showChildren) {
      css.push('showchildren');
    }

    return (
      <Tag className={css.join(' ')} ref={this.myRef}>
        <Default>
          {this.renderItem()}
          {this.renderStatus()}
          {this.renderOpenCloseIcon()}
          {this.state.showChildren && (
            <div className="sublist">
              <VisitList
                visits={this.props.visits}
                portRegistry={this.props.portRegistry}
                showingGMT={this.props.showingGMT}
                onUpdateStatus={this.onUpdateStatus}
                showClosingTimes={this.props.showClosingTimes}
                ports={this.ports}
                nextVoyage={this.props.nextVoyage}
                lang={this.state.lang}
              />
            </div>
          )}
        </Default>
        <Mobile>
          {!this.state.showChildren && (
            <React.Fragment>
              {this.renderItem()}
              {this.renderStatus()}
              {this.renderOpenCloseIcon()}
            </React.Fragment>
          )}
          {this.state.showChildren && (
            <div className="visitlist__mobile__wrapper">
              {this.renderVisitListHeader()}
              {this.renderChildren()}
            </div>
          )}
        </Mobile>
      </Tag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/vesselListItem.js